
import { Component, EventEmitter, Input, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { AgentType } from '../../enums/event.enum';
import { ChatStatus } from '../../enums/chat.enum';
import { ChatConfigResponse, ChatStatusMessage } from '../../models/chat.models';


@Component({
    selector: 'app-chat-toggle',
    templateUrl: './chat-toggle.component.html',
    styleUrls: ['./chat-toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChatToggleComponent {

    @Input() chatAgentType: AgentType;
    @Input() liveAgentName: string = "Live Agent";
    @Input() aiAgentName: string = "Saffron AI";
    @Input() chatStatus: ChatStatus;
    @Input() disableToggleButton: boolean = false;
    @Input() isAIChatSubscriptionActive: boolean = false;
    @Input() isMobileApp: boolean = false;
    @Input() chatScreenConfig: ChatConfigResponse;

    @Output() toggleChat: EventEmitter<AgentType> = new EventEmitter<AgentType>();

    constructor() {
    }

    get statusMessage(): ChatStatusMessage {
        const currentAgentName = this.chatAgentType == AgentType.HUMAN ? this.liveAgentName : this.aiAgentName;
        const otherAgentName = this.chatAgentType == AgentType.HUMAN ? this.aiAgentName : this.liveAgentName;

        let currentStatus = "";
        let callToAction = null;   
        
        switch (this.chatStatus) {
            case ChatStatus.CHAT_ACTIVE:
                currentStatus = `You're talking to ${currentAgentName}`;
                callToAction = this.chatAgentType == AgentType.AI ? "Talk to a live agent" : `Switch back to ${otherAgentName}`;
                break;
            case ChatStatus.WAITING_FOR_AGENT:
                currentStatus = this.chatAgentType == AgentType.AI ? "Connecting you to a live agent..." : `Switching you back to ${otherAgentName}...`;
                break;
            case ChatStatus.ENDING_CHAT:
                currentStatus = `Ending chat with ${currentAgentName}`;
                break;
        }
        return { currentStatus, callToAction };
    }

    onToggle(fromParent: boolean = false) {
        const agentType = this.chatAgentType == AgentType.HUMAN ? AgentType.AI : AgentType.HUMAN;
        if (!fromParent) this.toggleChat.emit(agentType);
    }
}